import { render, staticRenderFns } from "./NumberedItems.vue?vue&type=template&id=754a83f6&"
import script from "./NumberedItems.vue?vue&type=script&lang=js&"
export * from "./NumberedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports